import styles from "./Styles/Auth.module.css"
import authImage from "../Assets/authImage.png"
import Input from "../Components/Input"
import {BsEyeSlashFill,BsEyeFill} from "react-icons/bs"
import Button from "../Components/Button"
import { useState } from "react"
import GButton from "../Components/GButton"
import { useNavigate } from "react-router-dom"
import { AiFillInfoCircle } from "react-icons/ai"
import Modal from "../Components/Modal"

function Login() {

    const [passwordVisible, setPasswordVisible] = useState(false)
    const [errorVisible, setErrorVisible] = useState(false)
    const [modalVisible, setModal] = useState(false)
    const navigate = useNavigate()

    const [data, setData] = useState({
        email: '',
        password: ''
    })

    const _LoginHandler = (e) => {
        e.preventDefault()
        if(data.email == '' || data.password == ''){
            setErrorVisible(true)
        } else {
            setErrorVisible(false)
            navigate('/dashboard')
        }
    }

    return <div className={styles.container}>

        {modalVisible && <Modal width={400}>
            <div className={styles.modal}>
            <AiFillInfoCircle color="#FF2727" size={32} /> 
            <h2>Oops</h2>
            <p>Sorry, seems your account is not verified
            with us yet. Kindly contact your supervisor
            and ask your administrator to approve
            the account.</p>
            <Button height={50} width={224} mt={22} title="Try Again" />
            </div>
        </Modal>}

        <div className={styles.authForm}>
        {errorVisible && <p className={styles.error}><AiFillInfoCircle /> Wrong credentials entered. Please check again.</p>}
            <form>
                <h2>Login</h2>
                <Input bgColor={errorVisible && '#fff'} label="Email Address/Mob Number" onChange={(e)=>setData({...data,email:e.target.value})} value={data.email} error={errorVisible} mb={20} type="email"/>
                <Input bgColor={errorVisible && '#fff'} label="Password" onChange={(e)=>setData({...data,password:e.target.value})} value={data.password} error={errorVisible} type={!passwordVisible ? "password" : 'text'} onClickRightHandler={()=>setPasswordVisible(!passwordVisible)} rightIcon={!passwordVisible ? <BsEyeSlashFill size={22} color="#D2DADE" /> : <BsEyeFill size={22} color="#D2DADE" />} />
                <p onClick={()=>navigate('/login/forgot_password')} className={styles.forgot}>Forgot password?</p>

                <Button height={50} radius={10} mt={20} onClickHandler={(e)=>_LoginHandler(e)} title="Login" />

                <div className={styles.orSeparator}>
                    <p>or</p>
                </div>

                <GButton title="Login with Google" onClickHandler={null} />
            </form>
        </div>


        <div className={styles.authImage}>
            <img src={authImage} />
        </div>
    </div>
}

export default Login